import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .max(155, "Name must not exceed 155 characters"),
  description: Yup.string().required("Description is required"),
  price: Yup.string().typeError("").required("Price is required"),
  billable: Yup.string()
    .oneOf(
      ["monthly", "yearly", "quarterly", "semi-annually"],
      "Invalid billing period"
    )
    .required("Billing period is required"),
  app: Yup.string()
    .oneOf(
      [
        "pharmtrix-retail",
        "pharmtrix-wholesale",
        "labtrix",
        "centrix",
        "billtrix",
      ],
      "Invalid app type"
    )
    .required("App type is required"),
  features: Yup.string().required("Features are required"),
  branches_limit: Yup.string().required("Kindly input number of branches"),
  users_limit: Yup.string().required("Kindly input number of users"),
  stripe_product: Yup.string().required("Stripe product is required"),
  stripe_price: Yup.string().required("Stripe price is required"),
  apply_promo: Yup.string()
    .oneOf(["true", "false"], "Invalid promo selection")
    .required("Promo application status is required"),
  discounted_amount: Yup.string()
    .test('discount-required', 'Discounted amount is required when applying promo', function(value) {
      return this.parent.apply_promo === 'true' ? value && value.length > 0 : true;
    })
});

export default validationSchema; 